import { useState } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { dataGridCol } from '@shared/components/grid/common';
import { Wrapper } from '@styles/CommonStyles';
import { ITeamTypeType } from '../../interfaces';
import { TeamTypeModal } from './TeamTypeModal';
import { requestCreateTeamType, requestDeleteTeamType, requestUpdateTeamType } from './queries';

class TeamTypeModel {
  id = '';
  name = '';

  constructor(data?: ITeamTypeType) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
    }
  }
}

const columns: GridColDef[] = [
  dataGridCol('name', {
    flex: 1,
  }),
];

interface ITeamTypesProps {
  teamTypes: ITeamTypeType[];
}

export const TeamTypes = ({ teamTypes }: ITeamTypesProps) => {
  const [teamTypeToEdit, setTeamTypeToEdit] = useState<ITeamTypeType | null>(null);
  const [teamTypeModalPosition, setTeamTypeModalPosition] = useState(0);

  const gridActions = {
    onEdit: (data: ITeamTypeType) => {
      setTeamTypeToEdit(data);
      setTeamTypeModalPosition(prevState => prevState + 1 );
    },
    onDelete: (data: ITeamTypeType) => requestDeleteTeamType(data.id),
  };

  const onSubmitModal = async (type: ITeamTypeType) => {
    if (type.id) {
      await requestUpdateTeamType(type);
    } else {
      await requestCreateTeamType(type.name);
    }

    setTeamTypeToEdit(null);
    setTeamTypeModalPosition(0);
  };

  return (
    <Wrapper>
      <PhoenixGrid
        autoHeight
        withHeader
        canNotCopy
        name="Team Type"
        pageSize={25}
        columns={columns}
        loading={!teamTypes}
        rows={teamTypes || []}
        actions={gridActions}
        buttonTitle="Add Team Type"
        onButtonClick={() => setTeamTypeToEdit(new TeamTypeModel())}
      />

      {teamTypeToEdit && (
        <TeamTypeModal
          type={teamTypeToEdit}
          teamTypeModalPosition={teamTypeModalPosition}
          handleSubmit={onSubmitModal}
          handleClose={() => {
            setTeamTypeToEdit(null);
            setTeamTypeModalPosition(0);
          }}
        />
      )}
    </Wrapper>
  );
};
